import type { AclEntityMinInfoEntityTypeEnum } from "@eu.mdotm.api/sphere";
import type { AccessPermission, RichAccessControl } from "@eu.mdotm.api/smart-workspaces";
import { type IconProps, Icon } from "@mdotm/shadcn/legacy/components";
import { type Areas, roleByArea } from "./checkers/all";
import { validateACLPermissions } from "./checkers/shared";

const UserShareIcon = (
	props: {
		userId?: string;
		permission?: Array<AccessPermission>;
		entity: AclEntityMinInfoEntityTypeEnum;
		acl?: Array<RichAccessControl>;
	} & Omit<IconProps, "icon">,
): React.JSX.Element => {
	const areasByEntity = {
		BENCHMARK: "benchmark",
		INVESTMENT: "portfolio",
		MARKET_VIEW: "marketView",
		UNIVERSE: "universe",
		GROUP_UNIVERSE: "universe",
		REFERENCE: "targetPortfolio",
	} satisfies { [key in AclEntityMinInfoEntityTypeEnum]: Areas };

	const currentEntity = areasByEntity[props.entity];
	const { userId, permission, entity, acl, ...iconProps } = props;
	if ((props.acl?.length ?? 0) <= 1) {
		return <></>;
	}

	if (validateACLPermissions(userId!, [{ userId, permissions: permission }], roleByArea[currentEntity].OWNER)) {
		return <Icon icon="share" size={16} {...iconProps} />;
	}

	if (validateACLPermissions(userId!, [{ userId, permissions: permission }], roleByArea[currentEntity].EDITOR)) {
		return <Icon icon="share" size={16} {...iconProps} />;
	}

	if (validateACLPermissions(userId!, [{ userId, permissions: permission }], roleByArea[currentEntity].VIEWER)) {
		return <Icon icon="show" size={16} {...iconProps} />;
	}

	return <></>;
};

export default UserShareIcon;
